import {
	Box,
	FormGroup,
	FormControlLabel,
	Switch,
	Typography
} from '@mui/material';
import React from 'react';

const SwitchInput = ({ value, label, name, handleChange, className = '' }) => {
	return (
		<FormGroup className={className} row>
			<FormControlLabel
				control={
					<Switch
						checked={value}
						onChange={handleChange}
						name={name}
						color="primary"
					/>
				}
				label={<Typography variant="body1">{label}</Typography>}
			/>
		</FormGroup>
	);
};

export default SwitchInput;
